var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('img',{attrs:{"src":require("@/assets/yklogo2.png"),"alt":""}}),_c('p',[_vm._v("全国电话咨询热线：400-642-0148 ")])])
}]

export { render, staticRenderFns }